/**
 * @module ProductTabset
 * @description
 */
import React, { FC, useState } from 'react';
import Component from 'ui/components/Component';
import Tab from './Tab';
import styles from './styles/index.module.css';

interface Product {
  name: string;
  heading: string;
  legal: string;
  valueProps: {
    heading: string,
    items: ( string|JSX.Element )[];
  }
}

interface Props {
  products: Product[];
  position: string;
}

const ProductTabset: FC<Props> = ( { ...props } ) => {
  const {
    products,
    position
  } = props;
  const [ activeTab, setActiveTab ] = useState( 2 );

  return (
    <Component
      inContainer
      className={ styles.component }
    >
      <div id="tabset_container" className={ styles.tabset }>
        <div className={ styles.tabList } role="tablist">
          { products.map( (product: Product, index: number) => (
            <button
              key={ index }
              className={ styles.tabItem }
              onClick={ () => setActiveTab( index ) }
              aria-selected={ activeTab === index }
              id={ `tabItem-${ index }` }
              role="tab"
              aria-controls={ `tabpanel-${ index }` }
              tabIndex={ activeTab === index ? 0 : -1 }
              data-visible={ activeTab === index }
              >
              { product.heading }
            </button>
          ) ) }
        </div>{ /* <-- .tabList --> */ }

        <div className={ styles.tabs }>
          { products.map( (product: Product, index: number) => (
            <Tab
              key={ index }
              position={ `${position} - PRODUCT TABS` }
              index={ index }
              product={ product }
              activeTab={ activeTab }
            />
          ) ) }
        </div>{ /* <-- .tabs --> */ }
      </div>
    </Component>
  );
};

ProductTabset.displayName = 'ProductTabset';

export default ProductTabset;
